<template>
  <v-slide-x-transition>
    <v-list-tile v-if="classification" class="py-1">
      <v-autocomplete
        v-model="feature"
        clearable
        item-text="name"
        item-value="id"
        :items="features"
        label="Atributos"
        :loading="loadingFeatures"
        open-on-clear
        prepend-icon="list"
      />
    </v-list-tile>
  </v-slide-x-transition>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { FeatureDoesNotExists } from "@/store/value-mapping/exceptions.js";

/**
 * A component to select and set the classification in the Value Mapping app.
 */
export default {
  computed: {
    ...mapState("valueMapping", [
      "classification",
      "features",
      "loadingFeatures"
    ]),
    feature: {
      get() {
        return this.$store.state.valueMapping.feature;
      },
      set(featureId) {
        this.setFeature(featureId);
      }
    }
  },
  watch: {
    /**
     * Get the features of the classification if there is any and update the feature by the route
     * if the there is any featureId in the route's params.
     */
    classification() {
      if (this.classification) {
        return this.getFeatures().then(this.updateFeatureByRoute);
      }
    },
    /**
     * Set the correspondent route when the feature changes.
     */
    feature() {
      this.updateFeatureRoute();
    },
    $route() {
      this.updateFeatureByRoute();
    }
  },
  methods: {
    ...mapActions("valueMapping", [
      "getFeatures",
      "setFeature",
      "updateFeatureRoute"
    ]),
    ...mapMutations("valueMapping", ["setFeatures"]),
    /**
     * Update the selected feature according to the featureId in the route.
     * If the feature does not exists it will try to go to the classification child route
     * or to the home of the app.
     */
    updateFeatureByRoute() {
      const notInFeaturesRoute = !this.$route.matched.some(
        ({ name }) => name === "valueMapping/classification/feature"
      );
      if (notInFeaturesRoute) return;

      const id = Number(this.$route.params.featureId);

      if (Number.isNaN(id)) {
        this.featureDoesNotExists(this.$route.params.featureId);
      }

      if (id && (!this.feature || id !== this.feature.id)) {
        try {
          this.setFeature(id);
        } catch (error) {
          if (error instanceof FeatureDoesNotExists) {
            this.featureDoesNotExists(id);
          }
        }
      }
    }
  }
};
</script>
